/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExternalValueItemDtov1 } from '../models/external-value-item-dtov-1';


/**
 * API for looking up externally-sourced dropdown values.
 */
@Injectable({
  providedIn: 'root',
})
export class ExternalValueListService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation filterExternalValueListV1
   */
  static readonly FilterExternalValueListV1Path = '/v1/value-lists/{listKey}/values';

  /**
   * Filter values in an external value list.
   *
   * Backs SurveyJS onChoicesLazyLoad. Substring match on the localized display text for the given locale, or on the raw value, capped at 50 results. Repeated tag.<key>=<value> params (e.g. tag.entity=Logitech%20Inc.) restrict results to items whose tags match every supplied key/value pair.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterExternalValueListV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterExternalValueListV1$Response(params: {
    listKey: string;
    locale?: string;
    search?: string;
    allParams: {
[key: string]: string;
};
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ExternalValueItemDtov1>>> {

    const rb = new RequestBuilder(this.rootUrl, ExternalValueListService.FilterExternalValueListV1Path, 'get');
    if (params) {
      rb.path('listKey', params.listKey, {});
      rb.query('locale', params.locale, {});
      rb.query('search', params.search, {});
      rb.query('allParams', params.allParams, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExternalValueItemDtov1>>;
      })
    );
  }

  /**
   * Filter values in an external value list.
   *
   * Backs SurveyJS onChoicesLazyLoad. Substring match on the localized display text for the given locale, or on the raw value, capped at 50 results. Repeated tag.<key>=<value> params (e.g. tag.entity=Logitech%20Inc.) restrict results to items whose tags match every supplied key/value pair.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterExternalValueListV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterExternalValueListV1(params: {
    listKey: string;
    locale?: string;
    search?: string;
    allParams: {
[key: string]: string;
};
  },
  context?: HttpContext

): Observable<Array<ExternalValueItemDtov1>> {

    return this.filterExternalValueListV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ExternalValueItemDtov1>>) => r.body as Array<ExternalValueItemDtov1>)
    );
  }

  /**
   * Path part for operation resolveExternalValueListV1
   */
  static readonly ResolveExternalValueListV1Path = '/v1/value-lists/{listKey}/values/resolve';

  /**
   * Resolve display values for one or more selected values.
   *
   * Backs SurveyJS onGetChoiceDisplayValue. Exact match only — the selection may not appear in the capped result set returned by the filter endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resolveExternalValueListV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  resolveExternalValueListV1$Response(params: {
    listKey: string;
    locale?: string;
    values: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ExternalValueItemDtov1>>> {

    const rb = new RequestBuilder(this.rootUrl, ExternalValueListService.ResolveExternalValueListV1Path, 'get');
    if (params) {
      rb.path('listKey', params.listKey, {});
      rb.query('locale', params.locale, {});
      rb.query('values', params.values, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExternalValueItemDtov1>>;
      })
    );
  }

  /**
   * Resolve display values for one or more selected values.
   *
   * Backs SurveyJS onGetChoiceDisplayValue. Exact match only — the selection may not appear in the capped result set returned by the filter endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resolveExternalValueListV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resolveExternalValueListV1(params: {
    listKey: string;
    locale?: string;
    values: Array<string>;
  },
  context?: HttpContext

): Observable<Array<ExternalValueItemDtov1>> {

    return this.resolveExternalValueListV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ExternalValueItemDtov1>>) => r.body as Array<ExternalValueItemDtov1>)
    );
  }

}
